import React from "react";
import { connect } from "react-redux";
import { Dropdown } from "react-bootstrap";
import { FiPlus, FiMoreHorizontal } from "react-icons/fi";
import moment from "moment";
import EmployeeShiftPatternEdit from "./EmployeeShiftPatternEditModal";
import ShiftPatternEdit from "../ShiftPatterns/ShiftPatternEditModal";
import DataTable from "components/DataTable";
import { showModal, hideModal } from "actions/modalActions";
import * as employeesActions from "actions/employeesActions";
import * as shiftsActions from "actions/shiftsActions";
import { employeesService } from "services";
import { errorFormating, canEditShiftPatterns } from "utils/utils";
import { withTranslation } from "react-i18next";

const ShiftPatternNewButtonToggle = React.forwardRef(({ onClick, title }, ref) => (
	<button
		ref={ref}
		type="button"
		title={title}
		className="btn btn-new"
		onClick={(e) => {
			e.preventDefault();
			onClick(e);
		}}
	>
		<FiPlus />
	</button>
));

class EmployeeShiftPatterns extends React.Component {
	constructor(props) {
		super(props);
		// console.log(props);

		this.closeModal = this.closeModal.bind(this);
		this.openNewEmployeeShiftPatternModal =
			this.openNewEmployeeShiftPatternModal.bind(this);
		this.openNewShiftPatternModal = this.openNewShiftPatternModal.bind(this);
		this.handleShiftPatternCreated = this.handleShiftPatternCreated.bind(this);
		this.handleShiftPatternCreatedForAssignment =
			this.handleShiftPatternCreatedForAssignment.bind(this);
		this.openAssignShiftPatternModal =
			this.openAssignShiftPatternModal.bind(this);
		this.openEditEmployeeShiftPatternModal =
			this.openEditEmployeeShiftPatternModal.bind(this);
		this.openEditShiftPatternModal = this.openEditShiftPatternModal.bind(this);
		this.openAlertModal = this.openAlertModal.bind(this);
		this.getShiftPatterns = this.getShiftPatterns.bind(this);

		this.state = {
			canEdit: canEditShiftPatterns(this.props.user),
		};
	}

	componentDidMount() {
		this.getShiftPatterns();
		this.getUbications();
		this.openRequestedAssignment();
	}

	componentDidUpdate(prevProps) {
		if (!prevProps.openAssignment && this.props.openAssignment) {
			this.openRequestedAssignment();
		}
	}

	openRequestedAssignment = () => {
		if (!this.props.openAssignment) return;
		this.openNewEmployeeShiftPatternModal();
		if (typeof this.props.onAssignmentRequestHandled === "function") {
			this.props.onAssignmentRequestHandled();
		}
	};

	async getShiftPatterns() {
		const employeeId = this.props.employee.id;
		await this.props.getEmployeeShiftPatterns(employeeId);
	}

	async getUbications() {
		const employeeId = this.props.employee.id;
		await this.props.getEmployeeUbications(employeeId);
	}

	closeModal() {
		this.props.hideModal();
	}

	handleShiftPatternCreated() {
		this.getShiftPatterns();
		if (typeof this.props.getSelectableShiftPatterns === "function") {
			this.props.getSelectableShiftPatterns();
		}
	}

	openAssignShiftPatternModal(shiftPattern) {
		const { employee } = this.props;

		this.props.showModal(
			{
				open: true,
				title: this.props.t("shiftPatterns.assignment.assign"),
				style: { width: "480px" },
				content: (
					<EmployeeShiftPatternEdit
						handleClose={this.closeModal}
						employee={employee}
						lockedShiftPatternId={shiftPattern?.id}
						lockedShiftPatternName={shiftPattern?.name}
						onDataChanged={this.props.onDataChanged}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	handleShiftPatternCreatedForAssignment(shiftPattern) {
		this.handleShiftPatternCreated();
		// Cerrar creación y abrir asignación en el siguiente tick para que
		// ReactModal limpie body/backdrop antes del nuevo modal.
		this.closeModal();
		window.setTimeout(() => {
			this.openAssignShiftPatternModal(shiftPattern);
		}, 0);
	}

	async openNewShiftPatternModal() {
		const loaders = [];

		if (typeof this.props.getDefaultShift === "function") {
			loaders.push(this.props.getDefaultShift());
		}
		if (typeof this.props.getShiftTypes === "function") {
			loaders.push(this.props.getShiftTypes());
		}
		if (typeof this.props.getSelectableShifts === "function") {
			loaders.push(this.props.getSelectableShifts());
		}

		if (loaders.length > 0) {
			await Promise.all(loaders);
		}

		this.props.showModal(
			{
				open: true,
				title: this.props.t("shiftPatterns.newShiftPattern"),
				style: { width: "980px", maxWidth: "calc(100vw - 32px)" },
				content: (
					<ShiftPatternEdit
						getShiftPatterns={this.handleShiftPatternCreated}
						handleClose={this.closeModal}
						onCreatedForAssignment={this.handleShiftPatternCreatedForAssignment}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	openNewEmployeeShiftPatternModal() {
		const { employee } = this.props;

		this.props.showModal(
			{
				open: true,
				title: this.props.t("shiftPatterns.assignment.assign"),
				style: { width: "480px" },
				content: (
					<EmployeeShiftPatternEdit
						handleClose={this.closeModal}
						employee={employee}
						onDataChanged={this.props.onDataChanged}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	openEditEmployeeShiftPatternModal(employee_shift_pattern) {
		const { employee } = this.props;

		this.props.showModal(
			{
				open: true,
				title: this.props.t("shiftPatterns.assignment.editAssignment"),
				style: { width: "480px" },
				content: (
					<EmployeeShiftPatternEdit
						employee_shift_pattern={employee_shift_pattern}
						employee={employee}
						handleClose={this.closeModal}
						onDataChanged={this.props.onDataChanged}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	openEditShiftPatternModal(employee_shift_pattern) {
		this.props.showModal(
			{
				open: true,
				title: this.props.t("shiftPatterns.assignment.editShiftPattern"),
				style: { width: "850px" },
				content: (
					<ShiftPatternEdit
						getShiftPatterns={this.getShiftPatterns}
						shift_pattern={employee_shift_pattern.shift_pattern}
						handleClose={this.closeModal}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	openDeleteEmployeeShiftPatternModal(idShiftPattern) {
		this.props.showModal(
			{
				open: true,
				style: { width: "400px" },
				title: this.props.t("shiftPatterns.assignment.deleteAssignment"),
				message: this.props.t("shiftPatterns.assignment.deleteConfirmation"),
				deleteAction: () => this.confirmDelete(idShiftPattern),
				closeModal: this.closeModal,
			},
			"delete"
		);
	}

	openAlertModal(message) {
		this.props.showModal(
			{
				open: true,
				title: this.props.t("shiftPatterns.assignment.deleteError"),
				style: { width: "400px" },
				message: message,
				closeModal: this.closeModal,
			},
			"alert"
		);
	}

	confirmDelete = async (idShiftPattern) => {
		const response = await employeesService.removeShiftPattern(
			this.props.employee.id,
			idShiftPattern
		);

		if (!response.ok) {
			let textError = errorFormating(response);
			this.openAlertModal(textError.id);
		} else {
			this.getShiftPatterns();
			if (typeof this.props.onDataChanged === "function") {
				this.props.onDataChanged();
			}
			this.closeModal();
		}
	};

	getColumns = () => {
		const { canEdit } = this.state;

		return [
			{
				key: "shift_pattern",
				header: this.props.t("shiftPatterns.assignment.headerShiftPattern"),
				sortAccessor: (row) => row.shift_pattern?.name || "",
				render: (row) => canEdit ? (
					<button className="btn-transparent btn-editable" onClick={() => this.openEditEmployeeShiftPatternModal(row)}>{row.shift_pattern.name}</button>
				) : row.shift_pattern.name,
			},
			{
				key: "start_day",
				header: this.props.t("shiftPatterns.assignment.headerStart"),
				render: (row) => moment(row.start_day).format("DD/MM/YY"),
			},
			{
				key: "end_day",
				header: this.props.t("shiftPatterns.assignment.headerEnd"),
				render: (row) => row.end_day ? moment(row.end_day).format("DD/MM/YY") : "-",
			},
			{
				key: "ubication",
				header: this.props.t("shiftPatterns.assignment.headerUbication"),
				sortAccessor: (row) => row.ubication?.name || "",
				render: (row) => row.ubication ? row.ubication.name : "-",
			},
		];
	};

	renderActions = (employee_shift_pattern) => (
		<Dropdown>
			<Dropdown.Toggle variant="action"><FiMoreHorizontal /></Dropdown.Toggle>
			<Dropdown.Menu>
				<Dropdown.Item as="button" onClick={() => this.openEditEmployeeShiftPatternModal(employee_shift_pattern)}>{this.props.t("shiftPatterns.assignment.editAssignmentAction")}</Dropdown.Item>
				<Dropdown.Item as="button" onClick={() => this.openEditShiftPatternModal(employee_shift_pattern)}>{this.props.t("shiftPatterns.assignment.editShiftPatternAction")}</Dropdown.Item>
				<Dropdown.Item as="button" onClick={() => this.openDeleteEmployeeShiftPatternModal(employee_shift_pattern.id)}>{this.props.t("common.delete")}</Dropdown.Item>
			</Dropdown.Menu>
		</Dropdown>
	);

	renderNewButton = () => (
		<Dropdown align="end">
			<Dropdown.Toggle as={ShiftPatternNewButtonToggle} title={this.props.t("shiftPatterns.assignment.createAssignment")} />
			<Dropdown.Menu>
				<Dropdown.Item as="button" onClick={this.openNewShiftPatternModal}>{this.props.t("shiftPatterns.assignment.createNewShiftPattern")}</Dropdown.Item>
				<Dropdown.Item as="button" onClick={this.openNewEmployeeShiftPatternModal}>{this.props.t("shiftPatterns.assignment.assign")}</Dropdown.Item>
			</Dropdown.Menu>
		</Dropdown>
	);

	getContent = () => {
		const { employee_shift_patterns } = this.props;
		const { canEdit } = this.state;
		if (this.props.employee_shift_patterns) {
			return (
				<div className="employee-profile-datatable-wrap">
					<DataTable
						tableClassName="table-shift-patterns table-employee-shift-patterns table-hover"
						columns={this.getColumns()}
						rows={employee_shift_patterns}
						rowKey={(row) => row.id}
						emptyMessage={this.props.t("shiftPatterns.assignment.noAssignments")}
						actionsColumn={{
							enabled: canEdit,
							render: this.renderActions,
							className: "td-actions",
							header: this.renderNewButton(),
						}}
					/>
				</div>
			);
		}
	};
	render() {
		return <>{this.getContent()}</>;
	}
}

const mapStateToProps = (state) => {
	return {
		employee_shift_patterns: state.employeesReducer.employee_shift_patterns,
		user: state.authReducer.user,
	};
};

const mapDispatchToProps = (dispatch) => ({
	hideModal: () => dispatch(hideModal()),
	showModal: (modalProps, modalType) => {
		dispatch(showModal({ modalProps, modalType }));
	},
	getEmployeeShiftPatterns: (id) =>
		dispatch(employeesActions.getEmployeeShiftPatterns(id)),
	getEmployeeUbications: (id) =>
		dispatch(employeesActions.getEmployeeUbications(id)),
	getSelectableShiftPatterns: () =>
		dispatch(shiftsActions.getSelectableShiftPatterns()),
	getDefaultShift: () => dispatch(shiftsActions.getDefaultShift()),
	getShiftTypes: () => dispatch(shiftsActions.getShiftTypes()),
	getSelectableShifts: () => dispatch(shiftsActions.getSelectableShifts()),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withTranslation()(EmployeeShiftPatterns));
